var magicStyles = [".digit[data-v-8a23f46a] {\n  flex-basis: calc((100% - ((var(--magic-code-entry-digits, 4) - 1) * 8px)) * (1 / var(--magic-code-entry-digits, 4)) + 0px);\n  flex-grow: 0;\n}"];

export default magicStyles;
